export default "__VITE_ASSET__lDbjsedF7QutsjelctGeuQ__"